import { TripRequestedNotification } from './components/TripRequestedNotification';
import type { NotificationMetaDataCallback } from './types';

export const PublicTripRequestedRenderer = TripRequestedNotification;

export const getMetaData: NotificationMetaDataCallback = (_notification) => {
  return {
    title: 'Trip Requested (Public Portal)',
  };
};
